import reduxCreator from '../libs/mk-womanizer/redux-creator';
import axiosPlugin from "../libs/mk-womanizer/ac-axios-plugin";


let redux = reduxCreator.type('USER_FRIEND').plugin(axiosPlugin);

let updateUserFriendAction = redux.fetchActionUpdate();

let deleteUserFriendAction = redux.fetchActionDelete();

export const TYPES = redux.types;

export const updateUserFriend = (userId, friendId = {}) => updateUserFriendAction(`/users/${userId}/friends/${friendId}/update-favorite`);
export const deleteUserFriend = (userId, friendId = {}) => deleteUserFriendAction(`/users/${userId}/friends/${friendId}`);
export const resetUserFriend = () => redux.actions.reset();

export const userFriend = redux.reducer();